var tableZone = document.querySelector(".table_zone");
var tableZone2 = document.querySelector(".table_zone_2");

var zoneSelected = null;
var periodesSelected = [];
var periodes = [];

var zoneSelected2 = null;
var periodesSelected2 = [];
var periodes2 = [];

if (tableZone) {
  periodes = Array.from(tableZone.querySelectorAll(".periode.selectable"));
  periodes.forEach(function (periode) {
    periode.addEventListener("click", function (e) {
      var el = e.currentTarget;
      selectNewZonePeriode(
        el.dataset.zone,
        parseInt(el.dataset.periode)
      );
    });
  });

  var selectNewZonePeriode = function (zone, periode) {
    if (zone !== zoneSelected) {
      zoneSelected = zone;
      periodesSelected = [periode];
    } else {
      console.log(periodesSelected);
      if (
        periodesSelected.length === 1 &&
        (periode + 1 == periodesSelected[0] ||
          periode - 1 == periodesSelected[0])
      ) {
        periodesSelected.push(periode);
      } else {
        periodesSelected = [periode];
      }
    }

    drawSelected();
  };

  var drawSelected = function () {
    tableZone.classList.add("selected");

    periodes.forEach(function (periode) {
      periode.classList.remove("selected");
    });

    periodes
      .filter(function (periode) {
        return (
          periode.dataset.zone == zoneSelected &&
          periodesSelected.includes(parseInt(periode.dataset.periode))
        );
      })
      .forEach(function (periode) {
        periode.classList.add("selected");
      });

    document.querySelector('input[name="zone"]').value = zoneSelected;
    document.querySelector('input[name="periodes"]').value =
      periodesSelected.join(" et ");

    // Renseigner les dates lisibles pour ETS
    var datesInput = document.querySelector('input[name="dates"]');
    if (datesInput) {
      var selectedCards = periodes.filter(function (p) {
        return (
          p.dataset.zone == zoneSelected &&
          periodesSelected.includes(parseInt(p.dataset.periode))
        );
      });
      var datesText = selectedCards
        .map(function (p) {
          var dateEl = p.querySelector('.date');
          return dateEl ? dateEl.textContent.trim() : '';
        })
        .filter(Boolean)
        .join(' | ');
      datesInput.value = datesText;
    }
  };

  function displayZone() {
    document.addEventListener("click", function (e) {
      e.target.classList.contains("zone-selector") && show(e.target);

      function show(e) {
        var tableZone = document.querySelector(
          ".table_zone .zone[data-zone='" + e.dataset.zone + "']"
        );
        if (tableZone) {
          reset();
          !e.classList.contains("active") && e.classList.add("active");
          !tableZone.classList.contains("active") &&
            tableZone.classList.add("active");
        }
      }
      function reset() {
        var currentSelector = document.querySelector(".zone-selector.active");
        var currentActive = document.querySelector(".table_zone .zone.active");
        currentActive && currentActive.classList.remove("active");
        currentSelector && currentSelector.classList.remove("active");
      }
    });
  }
  displayZone();
}

if (tableZone2) {
  periodes2 = Array.from(tableZone2.querySelectorAll(".periode.selectable"));
  periodes2.forEach(function (periode) {
    periode.addEventListener("click", function (e) {
      var el2 = e.currentTarget;
      selectNewZonePeriode$1(
        el2.dataset.zone,
        parseInt(el2.dataset.periode)
      );
    });
  });

  var selectNewZonePeriode$1 = function (zone, periode) {
    if (zone !== zoneSelected2) {
      zoneSelected2 = zone;
      periodesSelected2 = [periode];
    } else {
      console.log(periodesSelected2);
      if (
        periodesSelected2.length === 1 &&
        (periode + 1 == periodesSelected2[0] ||
          periode - 1 == periodesSelected2[0])
      ) {
        periodesSelected2.push(periode);
      } else {
        periodesSelected2 = [periode];
      }
    }

    drawSelected$1();
  };

  var drawSelected$1 = function () {
    tableZone2.classList.add("selected");

    periodes2.forEach(function (periode) {
      periode.classList.remove("selected");
    });

    periodes2
      .filter(function (periode) {
        return (
          periode.dataset.zone == zoneSelected2 &&
          periodesSelected2.includes(parseInt(periode.dataset.periode))
        );
      })
      .forEach(function (periode) {
        periode.classList.add("selected");
      });

    // Aligne la logique avec ETS: renseigne les champs cachés name="zone" et name="periodes"
    var container = document.getElementById("form-other-step-1");
    if (container) {
      var zoneInput = container.querySelector('input[name="zone"]');
      var periodesInput = container.querySelector('input[name="periodes"]');
      var datesInput2 = container.querySelector('input[name="dates"]');
      
      if (zoneInput) zoneInput.value = zoneSelected2;
      if (periodesInput) periodesInput.value = periodesSelected2.join(" et ");

      // Renseigner les dates lisibles pour Autre
      if (datesInput2) {
        var selectedCards2 = periodes2.filter(function (p) {
          return (
            p.dataset.zone == zoneSelected2 &&
            periodesSelected2.includes(parseInt(p.dataset.periode))
          );
        });
        var datesText2 = selectedCards2
          .map(function (p) {
            var dateEl = p.querySelector('.date');
            return dateEl ? dateEl.textContent.trim() : '';
          })
          .filter(Boolean)
          .join(' | ');
        datesInput2.value = datesText2;
      }
    }
  };

  function displayZone2() {
    document.addEventListener("click", function (e) {
      e.target.classList.contains("zone-selector") && show(e.target);

      function show(e) {
        var tableZone2 = document.querySelector(
          ".table_zone_2 .zone[data-zone='" + e.dataset.zone + "']"
        );
        if (tableZone2) {
          reset();
          !e.classList.contains("active") && e.classList.add("active");
          !tableZone2.classList.contains("active") &&
            tableZone2.classList.add("active");
        }
      }
      function reset() {
        var currentSelector = document.querySelector(".zone-selector.active");
        var currentActive = document.querySelector(
          ".table_zone_2 .zone.active"
        );
        currentActive && currentActive.classList.remove("active");
        currentSelector && currentSelector.classList.remove("active");
      }
    });
  }
  displayZone2();
}



// WEBPACK FOOTER //
// ./scripts/tableZone.js